import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {faPen, faQrcode, faTrash} from '@fortawesome/free-solid-svg-icons';
import {TranslateUtils} from '../../../_shared/translate-utils';
import {Subscription} from 'rxjs';
import {DumpsterDto, DumpsterService} from '../../../_services/configuration-services';
import {TranslateService} from '@ngx-translate/core';
import {AppRoles} from '../../../app.constants';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
    DumpsterManagementModalComponent
} from './dumpster-management-modal/dumpster-management-modal.component';
import {NotificationsService} from "../../../_shared/notifications.service";
import {ConfirmModalService} from "../../../_shared/_components/confirm-modal/confirm-modal.component";
import {ServiceQrCodeViewComponent} from "../service-qr-code-view/service-qr-code-view.component";

@Component({
    selector: 'app-dumpster-management',
    templateUrl: './dumpster-management.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DumpsterManagementComponent implements OnInit, OnDestroy {
    @Input() serviceId: string;

    dumpsters: DumpsterDto[] = [];

    AppRoles = AppRoles;

    // Icons
    icons = {
        edit: faPen,
        delete: faTrash,
        qrcode: faQrcode
    };

    crtLang = TranslateUtils.defaultLanguage;
    private langChangeSubscription$: Subscription;

    constructor(private readonly dumpsterService: DumpsterService,
                private readonly translateService: TranslateService,
                private readonly notificationService: NotificationsService,
                private readonly confirmService: ConfirmModalService,
                private readonly modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.fetchDumpsters();

        this.crtLang = this.translateService.currentLang;
        this.langChangeSubscription$ = this.translateService.onLangChange
            .subscribe(_ => {
                this.crtLang = this.translateService.currentLang;
            });
    }

    ngOnDestroy(): void {
        this.langChangeSubscription$.unsubscribe();
    }

    private fetchDumpsters(): void {
        this.dumpsterService.getDumpstersByServiceId(this.serviceId).pipe().subscribe(device => {
            this.dumpsters = device;
        });
    }

    createDumpster(): void {
        const modal = this.modalService.open(DumpsterManagementModalComponent, {centered: true, size: 'lg'});
        modal.componentInstance.serviceId = this.serviceId;
        modal.result
            .then(value => {
                    if (value === 'success') {
                        this.fetchDumpsters();
                    }
                },
                () => { /* catch the rejection */
                }
            );
    }

    updateDumpster(dumpster: DumpsterDto): void {

        const modal = this.modalService.open(DumpsterManagementModalComponent, {centered: true, size: 'lg'});
        modal.componentInstance.serviceId = this.serviceId;
        modal.componentInstance.dumpster = dumpster;
        modal.result
            .then(value => {
                    if (value === 'success') {
                        this.fetchDumpsters();
                    }
                },
                () => { /* catch the rejection */ }
            );
    }

    deleteDumpster(dumpster: DumpsterDto): void {

        this.confirmService.confirm({titleKey: 'common.confirmModal.title.delete'}).then(result => {
            if (result === ConfirmModalService.yes) {
                this.dumpsterService.deleteDumpster(dumpster.deviceId).pipe().subscribe(_ => {
                    this.notificationService.success({title: 'services.waste.notifications.deleteSuccess'});
                    this.fetchDumpsters()
                });
            }
        });

    }

    openQrCode(dumpster: DumpsterDto): void {
        const modal = this.modalService.open(ServiceQrCodeViewComponent, {centered: true});
        modal.componentInstance.serviceId = this.serviceId;
        modal.componentInstance.qrRawData = dumpster.deviceId;
        modal.componentInstance.qrName = dumpster['name' + this.crtLang.toUpperCase()];
    }
}
